/**
 * Created by lu on 2018/5/15.
 * 消息列表
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent:nb.view.List,
    view:{
        tag:'ul',
        'class':'msg-list'
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/notice/MsgList.js
// module id = 41
// module chunks = 0 1 3 4 7 8 9 10 12 13 14 15 16 18 19 21 25 26 27 28 30